import * as React from 'react';

export const FORBIDDEN_ERROR_PAGE_TEXTS = {
  NO_ACCESS: <>У&nbsp;вас нет доступа к&nbsp;запрашиваемой странице</>,
  GO_BACK: 'Вернуться на главную',
};
